import { createFileRoute } from '@tanstack/react-router';

import {
  EmailDocumentsView,
  type EmailDocumentsTab,
} from 'src/sections/admin/email-documents/email-documents-view';

export const Route = createFileRoute('/admin-skidog/email-documents')({
  validateSearch: (search: Record<string, unknown>): { tab: EmailDocumentsTab } => ({
    tab: search.tab === 'sections' ? 'sections' : 'templates',
  }),
  component: EmailDocumentsPage,
});

function EmailDocumentsPage() {
  const { tab } = Route.useSearch();
  return <EmailDocumentsView initialTab={tab} />;
}
